export default theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.border}`,
    backgroundColor: theme.palette.common.white,
    display: "flex",
    alignItems: "center",
    height: "64px",
    zIndex: theme.zIndex.appBar,
    direction: "rtl"
  },
  toolbar: {
    minHeight: "auto",
    width: "100%"
  },
  toolbarLtr: {
    minHeight: "auto",
    width: "100%",
    direction: "ltr"
  },
  title: {
    margin: theme.spacing(1)
  },
  menuButton: {
    margin: theme.spacing(1)
  },
  rtlIcon: {
    marginRight: "auto"
  },
  ltrIcon: {
    marginLeft: "auto"
  },
  signOutButton: {
    margin: theme.spacing(1)
  }
});
